import { ConversionAttribution } from '@/common/model/recommend/conversion'

import CheckBox from '@/components/view/atoms/checkbox/CheckBox'
import { CheckBoxType } from '@/components/view/atoms/checkbox/CheckBox'
import Text from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'
import DescriptionDisclosure from '@/components/view/molecules/disclosure/DescriptionDisclosure'

interface Props {
  value: ConversionAttribution
  onSelect(value: ConversionAttribution): void
}

/**
 * コンバージョン種別の切り替え。
 *
 * 直接とアシストは同じ受注を別の意味で数えた指標で、**合算してはいけない**。
 * 併記すると配信実績のテーブルが横に伸びて読みづらくなるため、切り替えで見せる。
 * 切り替わるのは CV数・CVR・売上・受注件数だけで、表示回数・クリック数・CTR・滞在時間は変わらない。
 */
const ConversionAttributionToggle = ({ value, onSelect }: Props) => (
  <ItemAlign align='center'>
    <CheckBox
      name='conversion'
      type={CheckBoxType.TOGGLE_TEXT}
      toggleText={{ left: '直接CV', right: 'アシストCV' }}
      checked={value === ConversionAttribution.DIRECT}
      onChange={(v) => onSelect(v ? ConversionAttribution.DIRECT : ConversionAttribution.ASSIST)}
      optionToggle
    />
    <DescriptionDisclosure>
      □<Text weight='bold'>直接CV</Text>
      <br />
      レコメンドパーツの商品を押下して<Text weight='bold'>該当商品を購入したもののみ</Text>
      <br />
      を計測
      <br />
      <br />□<Text weight='bold'>アシストCV</Text>
      <br /> レコメンドパーツ押下してから<Text weight='bold'>24時間以内の購入すべて</Text>を計測
    </DescriptionDisclosure>
  </ItemAlign>
)

export default ConversionAttributionToggle
